module.exports = __webpack_public_path__ + "img/tor-mit-zaun.9d7b3916.jpg";